import React from 'react';
import {Route, Switch, withRouter, Link} from 'react-router-dom';
import {inject, observer} from "mobx-react";
import MainContainer from './pages/main/MainContainer';
import styled from 'styled-components';
import ComposeContainer from './pages/compose/ComposeContainer';
import LoginTemplate from './pages/login/LoginTemplate';
import DetailTemplate from './pages/detail/templates/DetailTemplate';

export default
@inject('commonStore')
@withRouter
@observer
class App extends React.Component {
    componentDidMount(){ //새로고침하면 앱 다운되는 거 방지
      if(localStorage['ca_token']){
          this.props.commonStore.setAppLoaded(1);
      };
    };
    componentDidUpdate(){ //업데이트될 때 마다 토큰이 없으면 앱 강제종료
        if(localStorage['ca_token'] === undefined){
            this.props.commonStore.setAppLoaded(2);
        };
    };
    render() {
      if(this.props.commonStore.appLoaded) {
        return(
          <Wrap>
            <div className='black'></div>
            <Switch>
              <Route exact path='/' component={LoginTemplate}/>
              <Route path='/main' component={MainContainer}/>
              <Route path='/compose' component={ComposeContainer}/>
              <Route path='/detail/:type' component={DetailTemplate}/>
            </Switch>
          </Wrap>
        );
      } else {
        if(this.props.match.isExact){
          return(
            <Switch>
                <Route exact path='/' component={LoginTemplate}/>
            </Switch>
          );
        } else {
          return (
            <Box>
                <div className="box column">
                    <p><span role="img" aria-label=''>🔥 </span>잘못된 접근입니다. 로그인부터 하세요.</p>
                    <Link to="/"><button>로그인하러 가기</button></Link>
                </div>
            </Box>
        );
        }
      }
    };
};

const Wrap = styled.div `
  display: flex;
  justify-content: flex-start;

  &>.black {
    width: 54px;
    height: 100vh;
    background: #232533;
  }
`

const Box = styled.div`
  display: flex;
  justify-content: center;

  & >.column {
    flex-direction: column;
    font-size: 20px;
    padding: 30px;

    >p {
      font-weight: bold;
    }

    >a>button {
      margin-top: 20px;
      background: black;
      color: white;
      padding: 10px 20px;
      border-radius: 10px;
    }
  }
`